import { AgentsSlice } from './types/AgentSliceType'
import { Status } from '../../types'

export const initialState: AgentsSlice = {
	customAgents: {
		status: Status.IDLE,
		data: [],
	},
	commonAgents: {
		status: Status.IDLE,
		data: [],
	},
	providerAgents: {
		status: Status.IDLE,
		data: [],
	},
}
